// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"resumeLayout_layoutWrapper__38TJu","navbar":"resumeLayout_navbar__xTVY1","printBtn":"resumeLayout_printBtn__IiaXL"};